import TreeNode from '../../models/TreeNode';
import Event from '../../models/project/Event';
import Copy from '../util/Copy';

class TreeBranch {
  root: TreeNode;
  parents: TreeNode[];

  public constructor(
    root: TreeNode,
    parents: TreeNode[]
  ) {
    this.root = root;
    this.parents = parents;
  }
}

let TreeCreator = {
  /* http://www.d3noob.org/2014/01/tree-diagrams-in-d3js_11.html */
  flatDataToHierarchy: function(data: Array<TreeNode>): Array<TreeNode> {
    let dataMap = data.reduce(function(map, node) {
      map[node.name] = node;
      return map;
    }, {});

    let treeData: Array<TreeNode> = [];
    data.forEach(function(node) {
      // add to parent
      if (node.parent !== null) {
        let parent = dataMap[node.parent];

        if (parent) {
          parent.children.push(node);
        } else {
          // parent is null or missing
          treeData.push(node);
        }
      } else {
        treeData.push(node);
      }
    });

    return treeData;
  },

  mapComponents: function(components: any[]): Array<Event> {
    return components.map((component) => {
      return new Event(component.id, component.title, component.description, component.type, component.outcomes);
    });
  },

  mapBranches: function(branches: any[], components: Event[]): Array<TreeNode> {
    return branches.map((branch) => {
      let component = components.find((component) => {
        return component.id === branch.component;
      });

      if (component === undefined) {
        throw "No component found with id" + branch.component;
      } else {
        return new TreeNode(
          branch.name,
          branch.parent,
          component,
          branch.outcome,
          branch.probability,
          branch.estimate,
          branch.custom_estimate,
          []
        )
      }
    });
  },

  walkTreeForScenarios(
    tree: TreeNode[],
    scenarios: TreeNode[][] = [],
    branches: TreeBranch[] = []
    ): TreeNode[][] {
      // @todo json parse trick destroys custom option types, try something else
    const treeCopy = Copy(tree);
    const branchesCopy: TreeBranch[] = Copy(branches);

    const currentBranch = branchesCopy.pop();

    if (currentBranch === undefined) {
      const nextBranch = treeCopy.pop();

      if (nextBranch === undefined) { // tree walked through
        return scenarios;
      } else { // if current branch is undefined, it means this is the root branch of the tree
        const newBranches = [new TreeBranch(nextBranch, [])];
        return this.walkTreeForScenarios(treeCopy, scenarios, newBranches);
      }
    } else {
      if (currentBranch.root.children.length == 0) { // found the last outcome in scenario
        let newScenarios = scenarios.concat([currentBranch.parents.concat([currentBranch.root])]);

        return this.walkTreeForScenarios(treeCopy, newScenarios, branchesCopy);
      } else {  // current branch has child branches
        const childBranches = currentBranch.root.children.map((child) => {
          return new TreeBranch(child, currentBranch.parents.concat(currentBranch.root));
        });

        return this.walkTreeForScenarios(treeCopy, scenarios, branchesCopy.concat(childBranches));
      }
    }
  }
}

export default TreeCreator;



// WEBPACK FOOTER //
// ./src/services/tree/TreeCreator.ts